export default __webpack_public_path__ + "static/hero-desktop-301f9aaced850cf06e4e65d729b58f7f.webp";